import Icon from '../components/Icon.vue'

Icon.register({"wpexplorer":{"width":1792,"height":1792,"paths":[{"d":"M948 1028l163 329h-51l-175-350-171 350h-49l179-374-78-33 21-49 240 102-21 50zM563 436l304 130-130 304-304-130zM907 621l240 103-103 239-239-102zM1188 771l191 81-82 190-190-81zM1680 896q0-159-62-304t-167.5-250.5-250.5-167.5-304-62-304 62-250.5 167.5-167.5 250.5-62 304 62 304 167.5 250.5 250.5 167.5 304 62 304-62 250.5-167.5 167.5-250.5 62-304zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/wpexplorer.js